// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2IKMo","choiceBoxes":"toolbarselects_choiceBoxes__3knTH","simpleField":"toolbarselects_simpleField__34MFt"};